import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Select } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDomainList } from 'redux/slices/domainSlice';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { forgetUserPassword } from 'redux/slices/resetPassword';
import { GlobalOutlinedIcon, UserIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import {
  ForgotPasswordItem,
  InputWrap,
  SelectWrapper,
  StyledInput,
  StyledLink,
  StyledSelectInput,
  ThemeLoginButton,
} from 'pages/login/login_style';
import {
  getDomainSettingPageDetailsforloginUser,
  getOverrideGlobalStatus,
  getSettingPageDetails,
} from 'redux/slices/settingsSlice';
import LoginButtonLoader from 'component/loader_component/loginButtonLoader';
import Cookies from 'js-cookie';

export default function ForgetPasswordComponent({ theme }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const { domainList } = useSelector((state) => state.domainData);
  const { brandingData } = useSelector((state) => state.themes);
  const [domainId, setDomainId] = useState(null);
  const { passwordRuleEmail, passwordRuleUsername, overrideGlobalStatus, domainsettingsDataUser, SettingsData } =
    useSelector((state) => state.settings);
  const returnToSource = overrideGlobalStatus?.settings
    ? domainsettingsDataUser?.returnToSource ?? false
    : SettingsData?.returnToSource ?? false;
  const showDomains = brandingData ? brandingData.showDomains : true;
  const userNameInput = overrideGlobalStatus?.settings
    ? domainsettingsDataUser?.userName ?? true
    : passwordRuleUsername ?? true;
  const mailInput = overrideGlobalStatus?.settings ? domainsettingsDataUser?.email ?? true : passwordRuleEmail ?? true;
  const queryParams = new URLSearchParams(location.search);
  const src = queryParams.get('src');

  useEffect(() => {
    if (brandingData) {
      dispatch(getDomainList(brandingData.url));
      dispatch(getSettingPageDetails());
    }
  }, [brandingData]);

  useEffect(() => {
    if (Cookies.get('access_token')) {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    if (domainList.length) {
      form.setFieldsValue({ domainName: domainList[0].domainInfo });
      dispatch(getOverrideGlobalStatus(domainList[0].id));
      setDomainId(domainList[0].id);
      dispatch(getDomainSettingPageDetailsforloginUser(domainList[0].id));
    }
  }, [domainList]);

  const handleDomainChange = (value, option) => {
    setDomainId(Number(option.key));
    dispatch(getOverrideGlobalStatus(option.key));
    dispatch(getDomainSettingPageDetailsforloginUser(Number(option.key)));
  };
  const handleSourceNavigate = async () => {
    if (returnToSource && src) {
      window.location.href = src;
    } else {
      navigate('/login');
    }
  };

  const handleSubmit = async (values) => {
    const inputString = values.domainName ? values.domainName : domainList[0].domainInfo;
    const domainname = inputString.substring(0, inputString.indexOf('('));
    values.domainName = domainname;
    if (values.username) {
      values.username = values.username.trim();
    }
    if (!mailInput) {
      values.strEmail = '';
    }
    if (!userNameInput) {
      values.strUser = '';
    }
    const { protocol, hostname, port } = window.location;
    const currentDomain = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
    values.resetUrl = currentDomain;
    values.domainId = domainId;
    values.sourceUrl = src || '';
    try {
      setLoading(true);
      const sweetAlert = await dispatch(forgetUserPassword(values));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        if (sweetAlert?.payload.data === 'Failed to send password reset email. MailDelivery is not configured.') {
          await SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'info', buttonColor: 'blue' });
        } else {
          await SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
          await handleSourceNavigate();
        }
      } else if (sweetAlert?.payload.status === 400) {
        await SweetSweetAlert({ text: sweetAlert.payload.data, icon: 'error', buttonColor: 'red' });
      } else {
        await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='forgot-content-component'>
      <Form name='login' form={form} onFinish={handleSubmit} className='forgot-form-element'>
        <InputWrap className='forgot-input-wrapper'>
          {showDomains && (
            <SelectWrapper className={`${theme} forgot-select-wrapper`}>
              <div className='prefix-icon-wrapper forgot-icon-wrap'>
                {<GlobalOutlinedIcon className='icon-color forgot-icon-color' />}
              </div>
              <Form.Item
                name='domainName'
                rules={[{ required: true, message: 'Please enter the Domain name.' }]}
                className='forgot-form-item-fqdn'
              >
                <StyledSelectInput
                  className={`${theme} forgot-selectorbox-fqdn`}
                  size='large'
                  placeholder='Select Domain'
                  onChange={handleDomainChange}
                >
                  {domainList.length &&
                    domainList.map((item) => (
                      <Select.Option key={item.id} value={item.domainInfo} className='forgot-selectorbox-option-fqdn'>
                        {item.domainInfo.toLowerCase()}
                      </Select.Option>
                    ))}
                </StyledSelectInput>
              </Form.Item>
            </SelectWrapper>
          )}
          {userNameInput && (
            <Form.Item
              name='strUser'
              rules={[{ required: true, message: 'Please enter the User name.' }]}
              className='forgot-form-item-user'
            >
              <StyledInput
                className={`${theme} forgot-input-user`}
                size='large'
                prefix={<UserIcon className='icon-color' />}
                placeholder='Username'
              />
            </Form.Item>
          )}
          {mailInput && (
            <Form.Item
              name='strEmail'
              rules={[
                {
                  type: 'email',
                  message: 'The input is not a valid E-mail!',
                },
                {
                  required: true,
                  message: 'Please input your E-mail',
                },
              ]}
              className='forgot-form-item-email'
            >
              <StyledInput
                className={`${theme} forgot-input-email`}
                size='large'
                prefix={<UserIcon className='icon-color' />}
                placeholder='E-mail'
              />
            </Form.Item>
          )}
          <Form.Item className='forgot-form-item-submit'>
            <ThemeLoginButton className={`${theme} forgot-submit-button`} type='primary' disabled={loading}>
              {loading ? <LoginButtonLoader /> : 'Continue'}
            </ThemeLoginButton>
          </Form.Item>
          <ForgotPasswordItem disabled={loading} className='forgot-form-item-back'>
            <StyledLink className={`${theme} forgot-back-link`} to={returnToSource && src ? src : '/login'}>
              Back
            </StyledLink>
          </ForgotPasswordItem>
        </InputWrap>
      </Form>
    </div>
  );
}
